import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export type ListingSortState = {
  field: string;
  direction: 'asc' | 'desc' | null;
};

export interface ModuleListingState {
  sort?: ListingSortState | null;
}

export interface ListingPreferencesState {
  modules: Record<string, ModuleListingState>;
}

const initialState: ListingPreferencesState = {
  modules: {},
};

const listingPreferencesSlice = createSlice({
  name: 'listingPreferences',
  initialState,
  reducers: {
    setModuleSort: (
      state,
      action: PayloadAction<{
        moduleKey: string;
        sort: ListingSortState | null;
      }>
    ) => {
      const { moduleKey, sort } = action.payload;
      state.modules[moduleKey] = {
        ...state.modules[moduleKey],
        sort,
      };
    },
    hydrateModule: (
      state,
      action: PayloadAction<{
        moduleKey: string;
        sort?: ListingSortState | null;
      }>
    ) => {
      const { moduleKey, sort } = action.payload;
      state.modules[moduleKey] = {
        sort: sort ?? state.modules[moduleKey]?.sort ?? null,
      };
    },
    resetModule: (state, action: PayloadAction<{ moduleKey: string }>) => {
      const { moduleKey } = action.payload;
      delete state.modules[moduleKey];
    },
  },
});

export const { setModuleSort, hydrateModule, resetModule } =
  listingPreferencesSlice.actions;

export default listingPreferencesSlice;
